<template>
	<kaveh-popup width="1200px" v-if="isShow" :close="() => {isShow = false}" :confirm-when-close="true">
		<letter-compose v-if="branchId > 0" @complete="complete" />
		<branch-choose v-else />
	</kaveh-popup>
</template>
<script>
	import LetterCompose from '@/modules/aut/views/letter/compose/letter-compose.vue'
	import BranchChoose from '@/modules/hub/views/branch/branch-choose.vue'

	export default {
		components: {
			'letter-compose': LetterCompose,
			'branch-choose': BranchChoose
		},

		data() {
			return {
				isShow: true,
			}
		},

		computed: {
			branchId()
			{
				return this.$store.state.client.branchId || 0
			}
		},

		methods: {
			complete() {
				this.isShow = false;
			}
		}
	}
</script>
